import jsonp from 'jsonp';
import axios from 'axios';
import qs from 'qs';
import { HOST, DEFAULT_ERROR_MSG, NOT_LOGIN_MSG } from '../utils/config';
import { HostEnv } from '@jd/paimai-utils';
export default class baseService {

  static addParamSign(url) {
    let sign = '?';
    if (url.indexOf('?') !== -1) {
      sign = '&';
    }
    return `${url}${sign}`;
  }

  static jsonpMethod(urlWithParams) {
    return new Promise((resolve, reject) => {
      const random = Math.floor(Math.random() * 10000);
      jsonp(`${this.addParamSign(urlWithParams)}t=${random}&jsonp=cbdata${random}`, {name:`cbdata${random}`}, function(err, ret) {
        if (err) {
          reject(err)
        } else {
          //statusCode !== 200
          // if (ret.statusCode === 200 || ret.resultCode == '0000' || ret.statusCode === undefined) {
            resolve(ret)
          // }

          // else {
          //   reject(ret)
          // }

        }
      })
    })
  }

  static async axiosMethod(method = 'get', appid = 'paimai', functionId, data, options) {
    const loginTypeStr = HostEnv.getLoginTypeStr();
    return axios({
      method,
      url:  `${HOST.API}?appid=${appid}&functionId=${functionId}${loginTypeStr}`,
      data: method === 'post' ? qs.stringify({
        body: JSON.stringify(data)
      }) : {},
      params: method === 'get' ? {
        body: JSON.stringify(data)
      } : {},
      withCredentials: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      ...options
    }).then((res = {}) => {
      const { data: result, status } = res
      if (status === 200) {
        const { data, message, statusCode, status: statusResult } = result
        if (statusCode === 200 || statusResult === 200) {
          return data
        } else if (statusResult === 401) {
          return Promise.reject(new Error(NOT_LOGIN_MSG))
        } else {
          return Promise.reject(new Error(`${message || DEFAULT_ERROR_MSG}`))
        }
      } else {
        return Promise.reject(new Error(DEFAULT_ERROR_MSG))
      }
    })
  }
}
